// extracted by mini-css-extract-plugin
export default {"popover":"styles_popover__IRZC7","content":"styles_content__cK-G7"};